<template>
    <div>
        <div class="shadow_box rounded-lg p-6 relative flex flex-col">
            <p class="title"><strong>Pesquisa</strong></p>
            <form class="mt-1 w-full" @submit.prevent="reloadTable">

                <div class="flex flex-wrap mb-4 px-4">
                    <multi-select-input v-model="filters.SalesPromoterLinks.market_network" :multiple="true"
                        :options="marketNetworkSearch" class="lg:pr-6 w-full lg:w-1/4" label="Nome da rede" />
                </div>

                <div class="flex flex-shrink-0 flex-wrap items-center justify-start p-4 rounded-b-md gap-1">
                    <button
                        class="btn-purple px-6 py-2.5 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out"
                        @click.submit.prevent="pesquisar">
                        <font-awesome-icon icon="fa-magnifying-glass" class="text-white text-sm mr-0 lg:mr-2" />
                        Pesquisar
                    </button>

                    <button
                        class="btn flex items-center text-purple-100 font-roboto font-medium px-6 py-2.5 text-xs leading-tight uppercase border-solid border-2 border-purple-100"
                        @click="clearSearch">
                        <font-awesome-icon icon="fa-eraser" class="text-purple text-sm mr-0 lg:mr-2" />
                        Limpar
                    </button>
                </div>
            </form>
        </div>

        <Head title="Vínculos do promotor" />
        <div class="shadow_box rounded-lg p-6 mt-4">
            <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Vínculos do promotor</h1>
            <data-table v-if="loadTable" v-model:columns="columns" :route="'list/' + sales_promoter.id"
                :query="getQuery" no-data-label="Nenhuma regra cadastrada" no-result-label="Nenhuma regra encontrada">
                <template #table.cell.content.detail="{ value, row }">
                    <div class="place-self-center grid-cols-2 gap-4">
                        <span class="flex items-center justify-center text-sm">
                            <button class="rounded p-2 bg-purple-100 text-white" @click.prevent="openModalConfig(row)">
                                Ver Fornecedores<font-awesome-icon icon="fa-solid fa-angle-right" class="pl-2" />
                            </button>
                        </span>
                    </div>
                </template>

                <template #table.cell.content.actions="{ value, row }">
                    <div class="inline-grid grid-cols-2 gap-4 ">
                        <span @click="openModalEdit(row)"
                            class="bg-purple-200 text-white rounded p-2 cursor-pointer text-sm">
                            <font-awesome-icon icon="fa-pencil" class="text-white pr-2" />Editar
                        </span>
                        <span @click="openModalConfirmDelete(row)"
                            class="bg-red_delete text-white rounded p-2 cursor-pointer text-sm">
                            <font-awesome-icon icon="fa-trash-can" class="text-white pr-2" />Excluir
                        </span>
                    </div>
                </template>

                <template #grid.content.body.actions="{ value, row }">
                    <div class="inline-grid grid-cols-2 gap-4 ">
                        <span @click="openModalEdit(row)"
                            class="bg-purple-200 text-white rounded p-2 cursor-pointer text-sm">
                            <font-awesome-icon icon="fa-pencil" class="text-white pr-2" />Editar
                        </span>
                        <span @click="openModalConfirmDelete(row)"
                            class="bg-red_delete text-white rounded p-2 cursor-pointer text-sm">
                            <font-awesome-icon icon="fa-trash-can" class="text-white text-lg pr-2" />Excluir
                        </span>
                    </div>
                </template>

                <template #after.reload-button>
                    <button class="flex items-end font-roboto font-medium btn-purple uppercase"
                        @click.prevent="openModalEdit({})">
                        <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /><span
                            class="hidden lg:block">
                            Vínculos do Promotor</span>
                    </button>
                </template>
            </data-table>
        </div>
        <modal-delete ref="modalDelete" @confirm="reloadTable"></modal-delete>
        <modal-edit :modal-scrollable="false" ref="modalEdit" title="Regra" url="sales_promoter_link"
            @submitForm="reloadTable" id="modal-vinculo-promotor">
            <template #form="{ item }">
                <select-input v-model="item.market_network_id" :error="item.errors.market_network_id"
                    class="lg:pr-6 w-full lg:w-1/3" label="Rede" @change="loadMarket($event)">
                    <option :value="null" />
                    <option v-for="(value, name) in market_network_options_all" :key="name" :value="name">
                        {{ value }}
                    </option>
                </select-input>

                <select-input v-model="item.market_id" :error="item.errors.market_id" class="lg:pr-6 w-full lg:w-1/3"
                    label="Unidade" @change="loadProvider($event)">
                    <option :value="null" />
                    <option v-for="(value) in market_options_all" :key="value.name" :value="value.value">
                        {{ value.label }}
                    </option>
                </select-input>

                <multi-select-input appendTo="#modal-vinculo-promotor" v-model="item.providers" :multiple="true"
                    :options="this.provider_options_all" :error="item.errors.providers"
                    class="lg:pr-6 w-full lg:w-1/2 mt-6 mb-6" label="Fornecedor" />
            </template>
        </modal-edit>
        <modal ref="modalConfig" size="modal-lg" :modal-scrollable="true" :modal-backdrop="true">
            <template #header="{ item }">
                <div class="text-gray-777 font-roboto uppercase">
                    <span>Fornecedores</span>
                </div>
            </template>
            <template #body>
                <form action="">
                    <div class="flex">
                        <div class="w-full m-2">
                            <table class="w-full text-left">
                                <tr v-for="(itens, index) in this.provider" :key="index"
                                    class="text-black bg-indigo-300 text-left even:bg-even_table odd:bg-odd_table">
                                    <td>{{ itens.name }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </form>
            </template>
            <template #footer>
                <button type="button" @click.prevent="closeModalConfig"
                    class="px-6 py-2.5 bg-gray-600 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out">Fechar</button>
            </template>
        </modal>
    </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import ModalDelete from '@/Shared/ModalDelete'
import ModalEdit from '@/Shared/ModalEdit'
import MultiSelectInput from '@/Shared/MultiSelectInput'
import DataTable from '@/Shared/DataTable'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import Modal from '@/Shared/Modal'
import SwitchInput from '@/Shared/SwitchInput'

import { useMemorizeFilters } from '@/Mixins/MemorizeFilters'

export default {
    components: {
        Head,
        ModalDelete,
        ModalEdit,
        DataTable,
        TextInput,
        MultiSelectInput,
        SelectInput,
        SwitchInput,
        Modal,
    },
    layout: Layout,

    data() {
        return {
            search: {
                market_network: '',
            },
            pesquisaSalva: true,
            market_options_all: [],
            provider_options_all: [],
            loadTable: true,
            columns: [
                {
                    uniqid: 'market_network',
                    label: 'Rede',
                    field: 'market_network_id',
                    visible: true,
                    sortable: true,
                    sortOrder: 'asc',
                    classes: 'px-4 py-3 border-b text-sm',
                    headerClass: 'p-4 text-left',
                    format: (val, row) => row.market_network_label ? row.market_network_label : '',
                },
                {
                    uniqid: 'market_network',
                    label: 'unidade',
                    field: 'market_id',
                    visible: true,
                    sortable: true,
                    sortOrder: 'asc',
                    classes: 'px-4 py-3 border-b text-sm',
                    headerClass: 'p-4 text-left',
                    format: (val, row) => row.market_label ? row.market_label : '',
                },
                {
                    uniqid: 'detail',
                    label: 'Fornecedor',
                    field: 'id',
                    visible: true,
                    align: 'center',
                    classes: 'py-3 border-b',
                    headerClass: 'p-4',
                },
                {
                    uniqid: 'actions',
                    label: 'Ações',
                    field: 'id',
                    visible: true,
                    align: 'center',
                    classes: 'py-3 border-b',
                    headerClass: 'p-4',
                },
            ],
        }
    },
    computed: {
        getQuery() {
            return Object.entries(this.getFilters()).map(([key, val]) => `search2[${key}]=${val}`).join('&')
        },
    },
    props: {
        market_network_options_all: Object,
        sales_promoter: Object,
        marketNetworkSearch: Array,
    },
    methods: {
        async loadMarket(event) {
            await fetch(
                `/market/get-markets-mn/` + event.target.value,
            ).then(res => {
                res.json().then(json => {
                    this.market_options_all = json.marketList;
                })
            })
        },
        async loadProvider(event) {
            await fetch(
                '/provider/get-provider-mn/' + event.target.value,
            ).then(res => {
                res.json().then(json => {
                    this.provider_options_all = json.providerList
                })
            })
        },
        openModalConfirmDelete(item) {
            this.$refs.modalDelete.openModalDelete(item, `/sales_promoter_link/${item.id}`, `Deseja realmente excluir o vínculo ?`)
        },
        openModalEdit(item) {

            this.market_options_all = item.market_options_all,
                this.provider_options_all = item.provider_options_all,

                this.$refs.modalEdit.openModalEdit({
                    id: item.id,
                    sales_promoter_id: this.sales_promoter.id,
                    market_network_id: item.market_network_id,
                    market_id: item.market_id,
                    providers: item.providers,
                    errors: {},
                })
        },
        openModalConfig(item) {
            this.provider = item.provider,
                this.$refs.modalConfig.showModal = true;
        },
        closeModalConfig() {
            this.$refs.modalConfig.showModal = false;
        },
        reloadTable() {
            this.loadTable = false
            setTimeout(() => this.loadTable = true, 10)
        },
        clearSearch() {
            this.clearFilters()
            this.reloadTable();
        },

        pesquisar() {
            this.reloadTable();
        },
    },

    setup() {
        const { filtersStore, setFiltersComponent, getFiltersComponent, clearFiltersComponent } = useMemorizeFilters()

        setFiltersComponent('SalesPromoterLinks')

        const clearFilters = () => clearFiltersComponent('SalesPromoterLinks')
        const getFilters = () => getFiltersComponent('SalesPromoterLinks')

        return {
            getFilters,
            clearFilters,
            filters: filtersStore.filters
        }
    },
}
</script>
